import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@parrot-software/design-system';
import { LogOut } from '@parrot-software/design-system/icons';

import { ParrotLogo } from '@experimental-components/IconsComponents/ParrotLogo';

import { getUserCurrentStore } from 'utils/authTyped';

/**
 * Desktop wizard top bar — external to the Card, anchored above the right panel.
 * Layout: 3-column grid → store name (left), Parrot logo (center), Save & exit (right).
 * Hidden below the `lg` breakpoint (mobile/tablet use WizardHeader inside the Card).
 */
export const WizardTopBar = () => {
  const { t } = useTranslation('onboarding');
  const history = useHistory();
  const storeName = getUserCurrentStore()?.name ?? '';

  const handleSaveAndExit = () => {
    history.push('/signout');
  };

  return (
    <div className="hidden w-full grid-cols-3 items-center bg-background px-10 pb-3 pt-4 shadow lg:grid">
      <p className="truncate text-sm font-normal leading-5 text-muted-foreground">{storeName}</p>
      <div className="flex justify-center">
        <ParrotLogo className="h-12" />
      </div>
      <div className="flex justify-end">
        <Button
          aria-label={t('wizard.saveAndExit')}
          className="h-9 gap-2 px-2 text-sm font-medium leading-5 text-foreground"
          onClick={handleSaveAndExit}
          variant="ghost"
        >
          {t('wizard.saveAndExit')}
          <LogOut size={16} />
        </Button>
      </div>
    </div>
  );
};
